import { ApiKeys } from '@insta-club/api';
import { useBoolean } from '@insta-club/hooks';
import { Algoritm, Guides } from '@insta-club/models';
import { t } from '@insta-club/translations';
import { BottomSheet, GuideDialog } from '@insta-club/ui';
import { useMemo, useState } from 'react';
import { mutate } from 'swr';
import ProgramCategory from '../program-category';
import AlgorithmicProgram from './program';

interface Props {
    algorithms?: Algoritm[];
    programID: number;
    dayNumber: number;
    canPerformTask: boolean;
}

const AlgorithmicTask: React.FC<Props> = ({ algorithms, programID, dayNumber, canPerformTask }) => {
    const sheet = useBoolean();
    const [guide, setGuide] = useState<Guides>();

    const openGuide = (guide: Guides) => {
        sheet.onFalse();
        setTimeout(() => {
            setGuide(guide);
        }, 300);
    };

    const closeGuide = () => {
        setGuide(undefined);
        sheet.onTrue();
    };

    const { isDone, pendingCount } = useMemo(() => {
        const pending = algorithms?.filter((task) => !task.is_done).length ?? 0;
        return {
            isDone: algorithms?.length && pending === 0,
            pendingCount: pending
        };
    }, [algorithms]);

    const handleCloseSheet = () => {
        sheet.onFalse();
        mutate(ApiKeys.GET_PROGRAM_SHOW(programID, dayNumber));
    };

    return (
        <>
            <ProgramCategory
                title={t('program', t('algorithmic'))}
                description={
                    !algorithms || algorithms.length === 0
                        ? 'در این روز برنامه الگوریتمی ندارید.'
                        : pendingCount > 0
                          ? `${pendingCount} فعالیت الگوریتمی برای انجام دارید`
                          : 'تکمیل شده'
                }
                status={isDone ? 'done' : 'progress'}
                onClick={sheet.onTrue}
                disabled={!algorithms || algorithms.length === 0}
            />
            {algorithms ? (
                <BottomSheet
                    title={`${t('program')} ${t('algorithmic')}`}
                    open={sheet.value}
                    onClose={handleCloseSheet}
                >
                    <AlgorithmicProgram
                        onGuide={openGuide}
                        onGuideTask={openGuide}
                        programID={programID}
                        dayNumber={dayNumber}
                        algorithms={algorithms}
                        canPerformTask={canPerformTask}
                    />
                </BottomSheet>
            ) : null}
            <GuideDialog open={guide !== undefined} onClose={closeGuide} guide={guide} />
        </>
    );
};

export default AlgorithmicTask;

